module.exports = __webpack_public_path__ + "assets/9b3247a01060b413e79b19d91cb4eba9.png";